// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3fvmj","name":"Header_name__vsiay","birthday":"Header_birthday__q6sFP","skeleton":"Header_skeleton__2ka8A"};